import { render, staticRenderFns } from "./ItemKey.vue?vue&type=template&id=2398dd6a&"
import script from "./ItemKey.vue?vue&type=script&lang=js&"
export * from "./ItemKey.vue?vue&type=script&lang=js&"
import style0 from "./ItemKey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports